import { createSelector } from 'reselect'

export const getRecords = (state) => state.payments.records
export const getPaymentMethods = createSelector(getRecords, (records = {}) => Object.values(records))
export const getPaymentMethod = (methodId) => createSelector(getRecords, (records = {}) => records[methodId])
